package dk.smark.demo.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun ZoomButtons(
    onZoomIn: () -> Unit,
    onZoomOut: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.shadow(4.dp, shape = RoundedCornerShape(4.dp)),
        shape = RoundedCornerShape(4.dp),
        color = Color.White,
        tonalElevation = 4.dp,
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            IconButton(
                onClick = onZoomIn,
                modifier = Modifier.size(40.dp),
                colors = IconButtonDefaults.iconButtonColors(contentColor = Color(0xFF666666))
            ) {
                Text(text = "+", fontSize = 22.sp, color = Color(0xFF444444))
            }
            Surface(
                modifier = Modifier
                    .padding(horizontal = 6.dp)
                    .size(width = 28.dp, height = 1.dp),
                color = Color(0xFFCCCCCC)
            ) {}
            IconButton(
                onClick = onZoomOut,
                modifier = Modifier.size(40.dp),
                colors = IconButtonDefaults.iconButtonColors(contentColor = Color(0xFF666666))
            ) {
                Text(text = "−", fontSize = 22.sp, color = Color(0xFF444444))
            }
        }
    }
}